// Pure password policy used by both backend (DomainError) and frontend
// (live feedback in the activate / reset forms). Keeping the rules here
// guarantees the two sides cannot drift.

export const PASSWORD_MIN_LENGTH = 10;

export type PasswordRule = 'min_length' | 'uppercase' | 'number' | 'special';

export interface PasswordViolation {
  rule: PasswordRule;
}

const HAS_UPPERCASE = /[A-Z]/;
const HAS_NUMBER = /\d/;
const HAS_SPECIAL = /[^A-Za-z0-9]/;

export function validatePassword(plain: string): PasswordViolation[] {
  const out: PasswordViolation[] = [];
  if (plain.length < PASSWORD_MIN_LENGTH) out.push({ rule: 'min_length' });
  if (!HAS_UPPERCASE.test(plain)) out.push({ rule: 'uppercase' });
  if (!HAS_NUMBER.test(plain)) out.push({ rule: 'number' });
  if (!HAS_SPECIAL.test(plain)) out.push({ rule: 'special' });
  return out;
}

export function isPasswordStrong(plain: string): boolean {
  return validatePassword(plain).length === 0;
}
